// =========================================
// Testimonials — vanilla scroll slider
// =========================================
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.block-testimonials').forEach(function (block) {
        const track = block.querySelector('.block-testimonials__track');
        if (!track) return;

        const step = function () {
            const card = track.querySelector('.block-testimonials__card');
            return card ? card.getBoundingClientRect().width + 32 : 320;
        };

        const prev = block.querySelector('.block-testimonials__prev');
        const next = block.querySelector('.block-testimonials__next');

        if (prev) {
            prev.addEventListener('click', function () {
                track.scrollBy({ left: -step(), behavior: 'smooth' });
            });
        }
        if (next) {
            next.addEventListener('click', function () {
                track.scrollBy({ left: step(), behavior: 'smooth' });
            });
        }

        // Auto-slide on mobile only (arrows are hidden there). Advances one
        // card every few seconds and loops back to the start at the end.
        if (window.matchMedia('(max-width: 991.98px)').matches) {
            setInterval(function () {
                if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) {
                    track.scrollTo({ left: 0, behavior: 'smooth' });
                } else {
                    track.scrollBy({ left: step(), behavior: 'smooth' });
                }
            }, 3500);
        }
    });
});
